import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { VideoImageZoom } from "..";

type DiscussVideoImageProps = {
  selectedVideos: string[];
  imageUpload: string[];
  setShowAllImages: React.Dispatch<React.SetStateAction<number | null>>;
  showAllImages: number | null;
  isLocked?: boolean | (() => void);
  toggle?: boolean | (() => void);
};
const DiscussVideoImage: React.FC<DiscussVideoImageProps> = ({
  selectedVideos,
  imageUpload,
  setShowAllImages,
  showAllImages,
  isLocked,
  toggle,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null); // Create a ref using useRef
  const play = () => setPlaying(true);
  const pause = () => setPlaying(false); 
  
  if (!selectedVideos || !imageUpload) {
    return null;
  }
  const allMediaUrls: string[] = [];

  selectedVideos.forEach((media) => {
    if (media) {
      allMediaUrls.push(media);
    }
  });

  imageUpload.forEach((media) => {
    if (media) {
      allMediaUrls.push(media);
    }
  });
// console.log(allMediaUrls);

  const totalMedias = allMediaUrls.length || 0;

  const handleClick = (index: number) => {
    setShowAllImages(index);
    setCurrentIndex(index);
    if (typeof toggle === "function") {
      toggle();
    }
  };
  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < totalMedias - 1 ? prevIndex + 1 : prevIndex
    );
  };
  // console.log(allMediaUrls, "allMediaUrls");
  const handleClose = () => {
    if (typeof toggle === "function") {
      toggle();
    }
    setShowAllImages(null);
  };
  let videoHash: string, thumbnailHash: string;
  return (
    <div className="flex w-full bg-white">
      {allMediaUrls && allMediaUrls.length > 4 ? (
        <div
          className="grid grid-rows-3 grid-flow-col grid-cols-3 w-full mb-8 lg:h-[400px] h-[300px]"
          key={currentIndex * 2}
        >
          {allMediaUrls?.map((media, index) => {
            const ipfsHashes = media.match(/\bQm\w{44}\b/g);

            if (ipfsHashes) {
              [videoHash, thumbnailHash] = ipfsHashes;
            }
            return (
              index === 0 && (
                <div
                  className={`row-span-full col-span-2 border relative overflow-hidden cursor-pointer ${
                    totalMedias === index ? "selected" : ""
                  }`}
                  onClick={() => handleClick(index)}
                  key={index * 2}
                >
                  {selectedVideos.includes(media) ? (
                    <ReactPlayer
                      ref={playerRef}
                      key={index}
                      url={ipfsGatewayImage(videoHash)}
                      width="100%"
                      height="100%"
                      controls={true}
                      playing={playing}
                      onPlay={play}
                      onPause={pause}
                      volume={1}
                      muted={true}
                      light={ipfsGatewayImage(thumbnailHash)}
                    />
                  ) : (
                    <img
                      id="imga"
                      src={ipfsGatewayImage(media)}
                      alt=""
                      className="w-full object-cover h-full object-center"
                    />
                  )}
                </div>
              )
            );
          })}
          {allMediaUrls &&
            allMediaUrls?.slice(1, 4).map((media, index) => {
              const ipfsHashes = media.match(/\bQm\w{44}\b/g);

              if (ipfsHashes) {
                [videoHash, thumbnailHash] = ipfsHashes;
              }
              return (
                <div
                  className="h-full relative overflow-hidden"
                  key={index * 3}
                  onClick={() => handleClick(index + 1)}
                >
                  <div className="border w-full h-full relative cursor-pointer">
                    {selectedVideos.includes(media) ? (
                      <ReactPlayer
                        ref={playerRef}
                        key={index}
                        url={ipfsGatewayImage(videoHash)}
                        width="100%"
                        height="100%"
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        light={ipfsGatewayImage(thumbnailHash)}
                      />
                    ) : (
                      <img
                        id="imga"
                        src={ipfsGatewayImage(media)}
                        alt=""
                        className="w-full object-cover h-full object-center"
                      />
                    )}
                  </div>
                  {index === allMediaUrls?.slice(1, 4).length - 1 && (
                    <div
                      className="w-full h-full text-white text-center bg-[rgba(0,0,0,0.7)] top-0 right-0 absolute font-Poppins text-2xl items-center flex justify-center cursor-pointer"
                      key={index * 4}
                      onClick={() => setShowAllImages(4)}
                    >
                      <p>+ {allMediaUrls?.length - 4}</p>
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      ) : allMediaUrls && allMediaUrls?.length > 3 ? (
        <div className="flex flex-col w-full mb-8 lg:h-[350px] h-[250px]">
          {allMediaUrls?.map((media, index) => {
            const ipfsHashes = media.match(/\bQm\w{44}\b/g);

            if (ipfsHashes) {
              [videoHash, thumbnailHash] = ipfsHashes;
            }

            return (
              index === 0 && (
                <div className="flex w-full" key={index + 21}>
                  <div
                    className={`w-full border relative lg:h-[250px] h-[128px] overflow-hidden cursor-pointer ${
                      totalMedias === index ? "selected" : ""
                    }`}
                    onClick={() => handleClick(index)}
                  >
                    {selectedVideos.includes(media) ? (
                      <ReactPlayer
                        ref={playerRef}
                        key={index}
                        url={ipfsGatewayImage(videoHash)}
                        width="100%"
                        height="100%"
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        light={ipfsGatewayImage(thumbnailHash)}
                      />
                    ) : (
                      <img
                        id="imga"
                        src={ipfsGatewayImage(media)}
                        alt=""
                        className="w-full object-cover h-full object-center"
                      />
                    )}
                  </div>
                </div>
              )
            );
          })}
          <div className="grid grid-flow-row overflow-hidden col-span-3 grid-cols-3 w-full">
            {allMediaUrls?.map((media, index) => {
              const ipfsHashes = media.match(/\bQm\w{44}\b/g);

              if (ipfsHashes) {
                [videoHash, thumbnailHash] = ipfsHashes;
              }
              return (
                index !== 0 && (
                  <div key={index * 81} className="w-full">
                    <div className="relative w-full lg:h-[90%] lg:max-h-[90%] h-[100%] max-h-[120px] overflow-hidden">
                      <div
                        className="border-2 w-full h-full cursor-pointer"
                        onClick={() => handleClick(index)}
                      >
                        {selectedVideos.includes(media) ? (
                          <ReactPlayer
                            ref={playerRef}
                            key={index}
                            url={ipfsGatewayImage(videoHash)}
                            width="100%"
                            height="100%"
                            controls={true}
                            playing={playing}
                            onPlay={play}
                            onPause={pause}
                            volume={1}
                            muted={true}
                            light={ipfsGatewayImage(thumbnailHash)}
                          />
                        ) : (
                          <img
                            id="imga"
                            src={ipfsGatewayImage(media)}
                            alt=""
                            className="w-full object-cover h-full object-center"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </div>
        </div>
      ) : (
        <div className="flex w-full">
          {allMediaUrls?.length === 2
            ? allMediaUrls?.map((media, index) => {
                const ipfsHashes = media.match(/\bQm\w{44}\b/g);

                if (ipfsHashes) {
                  [videoHash, thumbnailHash] = ipfsHashes;
                }

                return (
                  <div
                    className="flex w-full bg-white mb-8 h-[250px]"
                    key={index * 99}
                  >
                    <div
                      className="h-full cursor-pointer flex justify-between gap-1 w-full overflow-hidden border relative"
                      onClick={() => handleClick(index)}
                    >
                      {selectedVideos.includes(media) ? (
                        <ReactPlayer
                          ref={playerRef}
                          key={index}
                          url={ipfsGatewayImage(videoHash)}
                          width="100%"
                          height="100%"
                          controls={true}
                          playing={playing}
                          onPlay={play}
                          onPause={pause}
                          volume={1}
                          muted={true}
                          light={ipfsGatewayImage(thumbnailHash)}
                        />
                      ) : (
                        <img
                          id="imga"
                          loading="lazy"
                          src={ipfsGatewayImage(media)}
                          alt=""
                          className="w-full object-cover h-full object-center"
                        />
                      )}
                    </div>
                  </div>
                );
              })
            : allMediaUrls?.length === 3 && (
                <div className="flex w-full mb-8">
                  {allMediaUrls.map((media, index) => {
                    const ipfsHashes = media.match(/\bQm\w{44}\b/g);

                    if (ipfsHashes) {
                      [videoHash, thumbnailHash] = ipfsHashes;
                    }

                    return (
                      index === 0 && (
                        <div
                          className="flex w-full"
                          key={index * 20}
                        >
                          <div
                            className={`w-full border relative overflow-hidden cursor-pointer ${
                              totalMedias === index ? "selected" : ""
                            } `}
                            onClick={() => handleClick(index)}
                          >
                            {selectedVideos.includes(media) ? (
                              <ReactPlayer
                                ref={playerRef}
                                key={index}
                                url={ipfsGatewayImage(videoHash)}
                                width="100%"
                                height="100%"
                                controls={true}
                                playing={playing}
                                onPlay={play}
                                onPause={pause}
                                volume={1}
                                muted={true}
                                light={ipfsGatewayImage(thumbnailHash)}
                              />
                            ) : (
                              <img
                                id="imga"
                                src={ipfsGatewayImage(media)}
                                alt=""
                                className="w-full object-cover h-full object-center"
                              />
                            )}
                          </div>
                        </div>
                      )
                    );
                  })}
                  <div className="grid grid-rows-2 h-auto w-full overflow-hidden">
                    {allMediaUrls?.map((media, index) => {
                      const ipfsHashes = media.match(/\bQm\w{44}\b/g);

                      if (ipfsHashes) {
                        [videoHash, thumbnailHash] = ipfsHashes;
                      }
                      return (
                        index !== 0 && (
                          <div
                            className="flex w-full overflow-hidden relative h-[198px]"
                            key={index + 33}
                          >
                            <div
                              className="w-full flex-1 border flex cursor-pointer"
                              onClick={() => handleClick(index)}
                            >
                              {selectedVideos.includes(media) ? (
                                <ReactPlayer
                                  ref={playerRef}
                                  key={index}
                                  url={ipfsGatewayImage(videoHash)}
                                  width="100%"
                                  height="100%"
                                  controls={true}
                                  playing={playing}
                                  onPlay={play}
                                  onPause={pause}
                                  volume={1}
                                  muted={true}
                                  light={ipfsGatewayImage(thumbnailHash)}
                                />
                              ) : (
                                <img
                                  id="imga"
                                  src={ipfsGatewayImage(media)}
                                  alt=""
                                  className="w-full object-cover h-full object-center"
                                />
                              )}
                            </div>
                          </div>
                        )
                      );
                    })}
                  </div>
                </div>
              )}
        </div>
      )}
      {allMediaUrls &&
        showAllImages !== null &&
        totalMedias > 0 &&
        isLocked && (
          <VideoImageZoom
            selectedVideos={selectedVideos}
            playing={playing}
            playerRef={playerRef}
            allMediaUrls={allMediaUrls}
            currentIndex={currentIndex}
            handlePrev={handlePrev}
            handleNext={handleNext}
            play={play}
            pause={pause}
            totalMedias={totalMedias}
            handleClose={handleClose}
          />
        )}
    </div>
  );
};

export default DiscussVideoImage;
